const CONSTANTS = {
  DEFAULT_LANGUAGE: 'en',
  ENGLISH: 'en'
}

export default CONSTANTS;